module.exports = __webpack_public_path__ + "static/media/phone.0635c084.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/phone.png
// module id = 56
// module chunks = 0